"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _monthlyBalanceStatement = require("@/api/financialManagement/monthlyBalanceStatement");
var _BillingDetails = _interopRequireDefault(require("./components/BillingDetails.vue"));
var _memberBillingDetails = _interopRequireDefault(require("./components/memberBillingDetails.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MonthlyBalanceStatement',
  components: {
    BillingDetails: _BillingDetails.default,
    memberBillingDetails: _memberBillingDetails.default
  },
  data: function data() {
    return {
      queryData: {
        scene: 0,
        //	统计场景:0-月份(月结对账) 1-会员(会员明细)
        type: 0,
        //	统计方式:0-汇总 1-明细
        billMonth: null,
        // 账单月份
        // settleStatus: '', // 结算状态：0-未结算，1-已结算
        settleType: '',
        page: 1,
        size: 10
      },
      dataList: [],
      total: 0,
      // 条数
      loading: false,
      // loading

      // ------------------------------------------------------
      // 结算设置
      settlementData: [],
      dialogVisible: false,
      argumentData: {
        billMonth: '',
        settleType: 0,
        settleTime: ''
      },
      // 会员明细
      dialogVisible2: false,
      queryData1: {
        phoneNo: null,
        scene: 1,
        //	统计场景:0-月份(月结对账) 1-会员(会员明细)
        type: 0,
        //	统计方式:0-汇总 1-明细
        billMonth: null,
        // 账单月份
        memberId: null,
        // settleStatus: '', // 结算状态：0-未结算，1-已结算
        settleAmountStart: '',
        settleAmountEnd: '',
        incrAmountStart: '',
        incrAmountEnd: '',
        page: 1,
        size: 10
      },
      membershipDetailsData: [],
      membershipDetailsTotal: 0
    };
  },
  created: function created() {
    this.listBillStatsPaged();
  },
  methods: {
    listBillStatsPaged: function () {
      var _listBillStatsPaged2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.loading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _monthlyBalanceStatement.listBillStatsPaged)(params);
            case 1:
              res = _context.v;
              this.loading = false;
              if (res.code === 0) {
                this.dataList = res.data.data;
                this.total = res.data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function listBillStatsPaged() {
        return _listBillStatsPaged2.apply(this, arguments);
      }
      return listBillStatsPaged;
    }(),
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.listBillStatsPaged();
    },
    onInit: function onInit() {
      this.init();
      this.listBillStatsPaged();
    },
    init: function init() {
      this.queryData = {
        scene: 0,
        //	统计场景:0-月份(月结对账) 1-会员(会员明细)
        type: 0,
        //	统计方式:0-汇总 1-明细
        billMonth: null,
        // 账单月份
        // settleStatus: '', // 结算状态：0-未结算，1-已结算
        settleType: '',
        page: 1,
        size: 10
      };
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.listBillStatsPaged();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.listBillStatsPaged();
    },
    // 结算设置
    configureSettle: function () {
      var _configureSettle2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.argumentData);
              _context2.n = 1;
              return (0, _monthlyBalanceStatement.configureSettle)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.onInit();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.log(_t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function configureSettle() {
        return _configureSettle2.apply(this, arguments);
      }
      return configureSettle;
    }(),
    onPlatformDetail: function onPlatformDetail(val) {
      this.settlementData = [val];
      this.dialogVisible = true;
    },
    onConfirmSettings: function onConfirmSettings() {
      var _this = this;
      this.argumentData.billMonth = this.settlementData[0].billMonth;
      this.$confirm('是否确认结算?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.configureSettle();
      });
    },
    // 账单详情------------------------
    onBillingDetails: function onBillingDetails(val) {
      this.$refs.billingDetails.open(val);
    },
    onBillingDetails1: function onBillingDetails1(val) {
      this.$refs.memberBillingDetails.open(val);
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 会员明细-----------------------------------
    listBillStatsPaged1: function () {
      var _listBillStatsPaged3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.loading = true;
              params = (0, _objectSpread2.default)({}, this.queryData1);
              _context3.n = 1;
              return (0, _monthlyBalanceStatement.listBillStatsPaged)(params);
            case 1:
              res = _context3.v;
              this.loading = false;
              if (res.code === 0) {
                this.membershipDetailsData = res.data.data;
                this.membershipDetailsTotal = res.data.total;
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function listBillStatsPaged1() {
        return _listBillStatsPaged3.apply(this, arguments);
      }
      return listBillStatsPaged1;
    }(),
    onMemberAccountDetail: function onMemberAccountDetail(value) {
      this.queryData1.billMonth = value.billMonth;
      this.dialogVisible2 = true;
      this.listBillStatsPaged1();
    },
    onInquire1: function onInquire1() {
      this.queryData1.page = 1;
      this.queryData1.size = 10;
      this.listBillStatsPaged1();
    },
    onInitialize: function onInitialize() {
      this.queryData1 = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.queryData1), {
        phoneNo: null,
        scene: 1,
        //	统计场景:0-月份(月结对账) 1-会员(会员明细)
        type: 0,
        //	统计方式:0-汇总 1-明细
        memberId: null,
        settleStatus: '',
        // 结算状态：0-未结算，1-已结算
        settleAmountStart: '',
        settleAmountEnd: '',
        incrAmountStart: '',
        incrAmountEnd: '',
        page: 1,
        size: 10
      });
      this.listBillStatsPaged1();
    },
    handleSizeChange1: function handleSizeChange1(val) {
      this.queryData1.size = val;
      this.listBillStatsPaged1();
    },
    handleCurrentChange1: function handleCurrentChange1(val) {
      this.queryData1.page = val;
      this.listBillStatsPaged1();
    },
    handleClose1: function handleClose1(done) {
      done();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => { })
    },
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.memberName
        }
      });
    }
  }
};